import { NgModule } from '@angular/core';
import { NoPreloading, RouterModule, Routes } from '@angular/router';
import { AutoLoginAllRoutesGuard } from 'angular-auth-oidc-client';
import * as _ from 'lodash';

import { environment } from '../environments/environment';
import { BundlesPageResolver } from './core/services/bundles-page.resolver';
import { ProposalResolver } from './core/services/proposal-resolver.service';
import { ReviewResolver } from './core/services/review-resolver.service';
import { UnityDirectResolver } from './core/services/unity-direct-resolver.service';
import { CanActivateBundlesPage } from './modules/bundles-page/can-activate-bundles-page.service';
import { ErrorComponent } from './shared/components/error/error.component';
import { SessionTimeoutPlaceholderComponent } from './shared/components/session-timeout-placeholder/session-timeout-placeholder.component';
import { adminGuard } from './modules/admin/adminGuard';

const routes: Routes = [
  {
    path: '',
    canActivate: _.compact([
      _.includes(['local', 'dev', 'qa'], environment.type)
        ? null
        : AutoLoginAllRoutesGuard
    ]),
    children: [
      {
        path: '',
        resolve: {
          unityDirectData: UnityDirectResolver
        },
        loadChildren: () =>
          import('./modules/unity-direct/unity-direct.module').then(
            m => m.UnityDirectModule
          )
      },
      {
        path: 'admin',
        canActivate: [adminGuard],
        loadChildren: () =>
          import('./modules/admin/admin.module').then(m => m.AdminModule)
      },
      {
        path: 'bundles',
        canActivate: [CanActivateBundlesPage],
        resolve: {
          bundlesPageData: BundlesPageResolver
        },
        loadChildren: () =>
          import('./modules/bundles-page/bundles-page.module').then(
            m => m.BundlesPageModule
          )
      },
      {
        path: 'billing',
        resolve: {
          unityDirectData: UnityDirectResolver
        },
        loadChildren: () =>
          import(
            './modules/billing-reconciliation/billing-reconciliation.module'
          ).then(m => m.BillingReconciliationModule)
      },
      {
        path: 'unity-express',
        resolve: {
          unityDirectData: UnityDirectResolver
        },
        loadChildren: () =>
          import('./modules/unity-express/unity-express.module').then(
            m => m.UnityExpressModule
          )
      },
      {
        path: 'review',
        resolve: {
          loan: ReviewResolver,
          reviewSheetData: ProposalResolver
        },
        loadChildren: () =>
          import('./modules/review-sheet/review-sheet.module').then(
            m => m.ReviewSheetModule
          ),
        runGuardsAndResolvers: 'always'
      },
      {
        path: '',
        redirectTo: '/review',
        pathMatch: 'full'
      },
      {
        path: 'los/post',
        redirectTo: '/review',
        pathMatch: 'full'
      },
      {
        path: 'session-timeout',
        component: SessionTimeoutPlaceholderComponent
      }
    ]
  },
  { path: 'error', component: ErrorComponent },
  { path: '**', redirectTo: 'error' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: NoPreloading,
      onSameUrlNavigation: 'reload'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
